export default function formatTimelineViewCardLocationName(calendarEvent: CalendarEvent) {
    const locationParts = [calendarEvent.city, calendarEvent.postal_code].filter(Boolean)
    return locationParts.join(", ")
}
